/**
 * Action types for cinema reducer
 */
export default {
    FETCH_INIT    : "CINEMAS/FETCH_INIT",
    FETCH_SUCCESS : "CINEMAS/FETCH_SUCCESS"
};
